import React from "react";
import { Megaphone, Plus, Trash2, Rocket } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function DesiredOutcomeCard({ value, onChange }) {
  return (
    <div className="glass rounded-2xl p-6 border border-accent/30" data-testid="goals-desired-outcome">
      <Label className="mb-1 block font-bold flex items-center gap-2"><Rocket className="w-4 h-4 text-accent" /> ماذا تريد أن تصل إليه؟</Label>
      <p className="text-xs text-muted-foreground mb-3">اكتبها بكلماتك (مثال: ٥٠ عميلاً جديداً شهرياً، فتح فرع ثانٍ، أن أصبح الخيار الأول في حيّي). يبني الذكاء الاصطناعي الأهداف والحملات عليها.</p>
      <Textarea value={value} onChange={(e) => onChange(e.target.value)} rows={2} className="bg-secondary border-border" placeholder="أريد أن…" data-testid="goals-desired-outcome-input" />
    </div>
  );
}

export function CampaignSuggestionsCard({ items, onChange }) {
  const update = (i, field, val) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: val };
    onChange(next);
  };
  return (
    <div className="glass rounded-2xl p-6 border border-border" data-testid="goals-campaigns">
      <div className="flex items-center justify-between mb-1">
        <Label className="font-bold flex items-center gap-2"><Megaphone className="w-4 h-4 text-primary" /> الحملات المقترحة لتحقيق أهدافك</Label>
        {items.length < 5 && (
          <Button type="button" size="sm" variant="outline" onClick={() => onChange([...items, { name: "", idea: "", serves: "", timing: "", platform: "Instagram" }])} className="gap-1" data-testid="camp-add-btn"><Plus className="w-3.5 h-3.5" /> حملة باسمي</Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground mb-3">كل حملة تخدم نتيجة محددة. عدّل الأسماء أو أضف حملة بأي اسم تريده — عند إنشائها في التنفيذ تُبنى نصوصها وهاشتاقاتها على فكرتها وهدفها.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {items.map((c, i) => (
          <div key={i} className="rounded-xl border border-border bg-secondary/50 p-4 space-y-2" data-testid={`camp-card-${i}`}>
            <div className="flex items-center gap-2">
              <Input value={c.name} onChange={(e) => update(i, "name", e.target.value)} placeholder="اسم الحملة" className="bg-background border-border font-bold" data-testid={`camp-name-${i}`} />
              <Button type="button" size="icon" variant="ghost" onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="text-muted-foreground hover:text-destructive shrink-0 h-8 w-8" data-testid={`camp-remove-${i}`}><Trash2 className="w-3.5 h-3.5" /></Button>
            </div>
            <Input value={c.idea} onChange={(e) => update(i, "idea", e.target.value)} placeholder="فكرة الحملة ورسالتها" className="bg-background border-border text-sm" data-testid={`camp-idea-${i}`} />
            {(c.serves || c.timing) && (
              <p className="text-xs text-muted-foreground leading-relaxed">
                {c.serves && <span className="text-primary">تخدم: {c.serves}</span>}{c.serves && c.timing ? " · " : ""}{c.timing}{c.platform ? ` · ${c.platform}` : ""}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
